import React from "react";
import Select, { Option } from "rc-select";
import CCWCon from "./../../../../Components/M23/Withdrawal/CCW";

import Item from "./../../../Common/FormItem";
import Input from "./../../../Common/Input";
import WithdrawalMoney from "./../../../Common/WithdrawalMoney";
import BankAccount from "./../../../Common/BankAccount";
import CTCAccount from "./../../../Common/CTCAccount";
import WithdrawalSuccessTimer from "./../../../Common/WithdrawalSuccessTimer";

import translate from "./../../../../lib/translate/TranslateJs";
import { PendingWithdraw, ThresholdWithdraw, ChargeNoticeWithdraw, GlobalStorage, WithdrawKycModal } from './../../../Component/WithdrawModal'
import WithdrawalTutorialModal from "../../../../Web/Common/WithdrawalTutorialModal/WithdrawalTutorialModal";
function CCW(props) {
    return (
        <div className="CCW-container">
            <CCWCon
                {...props}
                Item={(props) => <Item className="" {...props} />}
                GlobalStorage={GlobalStorage}
                PendingWithdraw={PendingWithdraw}
                WithdrawKycModal={WithdrawKycModal}
                ThresholdWithdraw={ThresholdWithdraw}
                ChargeNoticeWithdraw={ChargeNoticeWithdraw}
                Input={Input}
                WithdrawalSuccessTimer={WithdrawalSuccessTimer}
                WithdrawalMoney={WithdrawalMoney}
                BankAccount={BankAccount}
                CTCAccount={CTCAccount}
                ExchangeExtra={(propCon) => (
                    <div className="exchageInfo">
                        <div>{propCon.tip1}</div>
                        <div>{propCon.tip2}</div>
                    </div>
                )}
                ExchangeExtra2={(propCon) => (
                    <div className="exchageInfo">
                        <p>{propCon.title}</p>
                        <ol>
                            <li>{propCon.tip1}</li>
                            <li>{propCon.tip2}</li>
                            <li>{propCon.tip3}</li>
                        </ol>
                        <div
                            className="showCalculation"
                            type="button"
                            onClick={propCon.onClick}
                        >
                            {propCon.btn}
                        </div>
                    </div>
                )}
                ExchangeExtra2Confirm={(propCon) => (
                    <div className="exchangeCalculationDiscription">
                        <div className="withdrawAmount">
                            <label>{propCon.money.label}</label>
                            <p>{propCon.money.value}</p>
                        </div>
                        <div>
                            <div className="exchangeDetail">
                                {propCon.usdtInfo.map((v, i) => (
                                    <div
                                        className="detailItem"
                                        key={"usdt_info_" + i}
                                    >
                                        <label>{v.label}</label>
                                        <p>{v.value}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div>
                            <div className="exchangeByLevel">
                                {propCon.rateInfo.map((v, i) => (
                                    <div key={"rate_info_" + i}>
                                        <label>{v.label}</label>
                                        <p>{v.value}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="yellowNote">{propCon.tip}</div>
                    </div>
                )}
                AddCTCAddress={(propCon) => (
                    <Input
                        className="addCTCAddress"
                        type="text"
                        readOnly
                        style={{ cursor: "pointer" }}
                        onClick={propCon.onEvent}
                        value={translate("添加 <#0#> 钱包地址")(
                            propCon.ctcType
                        )}
                    />
                )}
                AddressSelect={(propCon) => (
                    <Select
                        showSearch={false}
                        optionLabelProp="children"
                        value={propCon.currValue}
                        onChange={propCon.onSelectChange}
                    >
                        {propCon.list.map((v, i) => (
                            <Option
                                className={
                                    v.type === "push" ? "light-blue" : ""
                                }
                                value={v.walletAddress}
                                key={"address" + i}
                            >
                                {v.type === "push" ? (
                                    <>
                                        <p>{v.name + propCon.ctcType}</p>
                                        <div className="addIcon" />
                                    </>
                                ) : (
                                    <p>{v.walletName + " - " + v.walletAddress}</p>
                                )}
                            </Option>
                        ))}
                    </Select>
                )}
                SubmitBtn={(propCon) => (
                    <button
                        className={`primary-button ${propCon.disabled && 'disabled'}`}
                        disabled={propCon.disabled}
                        onClick={(e)=>{
                            // 避免同時觸發onClick and Form的onFinish
                            e.preventDefault();
                            propCon.onClick()
                        }}
                    >
                        {translate("提交")()}
                    </button>
                )}
                WithdrawalTutoria={(propCon) => (
                    <>
                        <button
                            className='tutorialButton'
                            onClick={propCon.onChange}
                        >
                            {translate("提款教程")()}
                        </button>
                        <WithdrawalTutorialModal visible={propCon.visible} onClose={propCon.onChange} />
                    </>
                )}
            />
        </div>
    );
}

export default CCW;
